var React = require('react');

function Sv (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#005293","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fecb00","d":"M176 0v192H0v96h176v192h96V288h368v-96H272V0h-96z","key":1})]);
}

Sv.defaultProps = {"id":"flag-icons-se","viewBox":"0 0 640 480"};

module.exports = Sv;

Sv.default = Sv;
